var map = {
	"./arrow-external-white.svg": "ff35",
	"./arrow-external.svg": "a76e",
	"./arrow-left.svg": "993b",
	"./arrow-right.svg": "77e3",
	"./arrow-up.svg": "632d",
	"./burger.svg": "f9a0",
	"./check-2.svg": "8108",
	"./check.svg": "ffd3",
	"./checkmark-icon.svg": "fc86",
	"./clock.svg": "1647",
	"./close-thin.svg": "08e2",
	"./close.svg": "c2aa",
	"./confirm-icon.svg": "7c93",
	"./dash.svg": "2256",
	"./download-circle.svg": "f90f",
	"./download.svg": "f52d",
	"./edit-icon.svg": "3d90",
	"./exit-icon.svg": "731c",
	"./eye-close.svg": "8fb6",
	"./eye.svg": "4118",
	"./layout-four.svg": "d2b5",
	"./layout-three.svg": "d6a8",
	"./loupe-plus.svg": "3cf0",
	"./menu-dots.svg": "62bb",
	"./pause-btn.svg": "f041",
	"./play-btn-2.svg": "d871",
	"./play-btn.svg": "5f4b",
	"./profile.svg": "8645",
	"./search.svg": "26eb",
	"./share-arrow.svg": "daa2",
	"./share.svg": "8e46",
	"./spinner.svg": "b472",
	"./tooltip-2.svg": "cdf3",
	"./tooltip.svg": "118d",
	"./triangle-down.svg": "5041",
	"./triangle-left.svg": "582d",
	"./triangle-right.svg": "82c7",
	"./triangle-up.svg": "e2d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c3b";